
<div mat-dialog-title
  >{{warningsData?.processArray?.length > 1 ? "Move securities into a group" : "Move security into a group" }}<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
  <mat-dialog-content>
    <div>
      <div style="margin-bottom: 10px;">
        <strong> {{warningsData?.processArray?.length > 1 ? warningsData?.processArray?.length + " securities selected" : warningsData?.processArray[0].securitySymbol + " selected" }}</strong>
      </div>
    </div>
    @if (this.loadingSpinner) {
      <div>
        <div class='loading-spinner-background'>&nbsp;</div>
        <div class='loading-spinner'></div>
        <div>Please wait a moment.</div>
        @if (warningsData?.processArray?.length > 1) {
          <div>iRebal is reviewing your selected securities to determine if
            they can be moved.
          </div>
        }
        @if (warningsData?.processArray?.length <= 1) {
          <div>iRebal is reviewing your selected security to determine if
            it can be moved.
          </div>
        }
      </div>
    }
    @if (!this.loadingSpinner && !isUiTest) {
      <div>
        @if (hasAffectedOrExternalSecurities()) {
          <div>
            <mat-card class="block error">
              <mat-card-title style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
                {{affectedSecurityCount() + ' of ' + this.warningsData?.processArray?.length + (responseObject?.responseUtilityMap?.affectedSecurities > 1 ? " SECURITIES" : " SECURITY ") +' CANNOT BE moved' }}
              </mat-card-title>
            </mat-card>
            <p> You cannot move securities when they are being used as an SMA , or as a target in a model, or as a
              target security in a scheduled rebalance or as an external security. You should first edit the security,
              model, or scheduled rebalance so that the security can be moved. Click view details below for more
            information.</p>
            @if (responseObject?.responseUtilityMap?.secWithModels > 0) {
              <div class="block" style="margin-top: 10px;"
                >
                @if (responseObject?.responseUtilityMap?.secWithModels > 1) {
                  <strong>
                  {{responseObject?.responseUtilityMap?.secWithModels + ' of ' + this.warningsData?.processArray?.length + ' selected securities are targets in ' + (responseObject?.responseUtilityMap?.affectedModel > 1 ? responseObject?.responseUtilityMap?.affectedModel + ' models.' : responseObject?.responseUtilityMap?.affectedModel + ' model.') }}</strong>
                }
                @if (responseObject?.responseUtilityMap?.secWithModels <= 1) {
                  <strong>
                  {{responseObject?.responseUtilityMap?.secWithModels + ' of ' + this.warningsData?.processArray?.length + ' selected security is target in ' + (responseObject?.responseUtilityMap?.affectedModel > 1 ? responseObject?.responseUtilityMap?.affectedModel + ' models.' : responseObject?.responseUtilityMap?.affectedModel + ' model.') }}</strong>
                }
              </div>
            }
            @if (responseObject?.responseUtilityMap?.secWithAccounts > 0) {
              <div class="block" style="margin-top: 10px;"
                >
                @if (responseObject.responseUtilityMap.secWithAccounts > 1) {
                  <strong>
                  {{responseObject.responseUtilityMap.secWithAccounts + ' of ' + this.warningsData?.processArray?.length + ' selected securities are specified as an SMA.' }}</strong>
                }
                @if (responseObject.responseUtilityMap.secWithAccounts <= 1) {
                  <strong>
                  {{responseObject.responseUtilityMap.secWithModels + ' of ' + this.warningsData?.processArray?.length + ' selected security is specified as an SMA.' }}</strong>
                }
              </div>
            }
            @if (responseObject?.responseUtilityMap?.secWithRebalances > 0) {
              <div class="block" style="margin-top: 10px;"
                >
                @if (responseObject.responseUtilityMap.secWithRebalances > 1) {
                  <strong>
                  {{responseObject.responseUtilityMap.secWithRebalances + ' of ' + this.warningsData?.processArray?.length + ' selected securities are being used in scheduled rebalances.' }}</strong>
                }
                @if (responseObject.responseUtilityMap.secWithRebalances <= 1) {
                  <strong>
                  {{responseObject.responseUtilityMap.secWithRebalances + ' of ' + this.warningsData?.processArray?.length + ' selected security is being used in scheduled rebalances.' }}</strong>
                }
              </div>
            }
            @if (responseObject?.responseUtilityMap?.externalSecurities > 0) {
              <div class="block" style="margin-top: 10px;"
                >
                @if (responseObject.responseUtilityMap.externalSecurities > 1) {
                  <strong>
                  {{responseObject.responseUtilityMap.externalSecurities + ' of ' + this.warningsData?.processArray?.length + ' selected securities are external securities.' }}</strong>
                }
                @if (responseObject.responseUtilityMap.externalSecurities <= 1) {
                  <strong>
                  {{responseObject.responseUtilityMap.externalSecurities + ' of ' + this.warningsData?.processArray?.length + ' selected security is an external security.' }}</strong>
                }
              </div>
            }
            <a (click)="viewDetails()">View details</a>
          </div>
        }
        @if (!hasAffectedOrExternalSecurities()) {
          <div>
            @if (warningsArray?.length > 0) {
              @if (hasAffectedSecuritiesAndPortfolios()) {
                <mat-card class="block warning">
                  <mat-card-title style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
                    {{responseObject?.responseUtilityMap?.securitiesAffected + ' OTHER ' + (responseObject?.responseUtilityMap?.securitiesAffected > 1 ? "securities or " : "security or ") + (responseObject?.responseUtilityMap?.affectedPortfolios) + (responseObject?.responseUtilityMap?.affectedPortfolios > 1 ? " portfolios " : " portfolio ") + "will lose some specified trading rules." }}
                  </mat-card-title>
                </mat-card>
              }
              @if (!hasAffectedSecuritiesAndPortfolios() && responseObject?.responseUtilityMap?.securitiesAffected > 0) {
                <mat-card class="block warning"
                  >
                  <mat-card-title style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
                    {{responseObject?.responseUtilityMap?.securitiesAffected + ' OTHER ' + (responseObject?.responseUtilityMap?.securitiesAffected > 1 ? "securities " : "security ") + "will lose some specified trading rules." }}
                  </mat-card-title>
                </mat-card>
              }
              @if (!hasAffectedSecuritiesAndPortfolios() && responseObject?.responseUtilityMap?.affectedPortfolios > 0) {
                <mat-card class="block warning"
                  >
                  <mat-card-title style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
                    {{responseObject?.responseUtilityMap?.affectedPortfolios + (responseObject?.responseUtilityMap?.affectedPortfolios > 1 ? " portfolios " : "portfolio ") + "will lose some specified trading rules." }}
                  </mat-card-title>
                </mat-card>
              }
              <div class="block">
                If you proceed, these other security record(s) will be affected as described below:
              </div>
              <!-- AG-GRID HERE-->
              <irb-inventory-grid
                [style.width]="'100%'"
                [style.height]="'180px'"
                [style.minHeight]="'120px'"
                [style.maxHeight]="'270px'"
                [showSideBar]="false"
                [gridOptions]="gridOptions"
                [frameworkComponents]='frameworkComponents'
                [rowData]='warningsArray'
              (gridReady)="onGridReady($event)"></irb-inventory-grid>
              <div class="block" style="margin-top:10px">
                <button (click)="exportList()" class="btn-medium-secondary export-btn">Export</button>
              </div>
              <div class="block"><strong>Move selections
              into: {{warningsData?.currentGroupSecurity?.securitySymbol}} </strong></div>
            }
            @if (warningsArray?.length <= 0) {
              <div class="block" style="margin-top:10px;">
                <p>{{'iRebal is ready to move the selected ' + (warningsData?.processArray?.length > 1?" securities": " security") + ' into the group security specified below.'}}</p>
                @if (warningsData?.processArray?.length > 1 ) {
                  <p>Note: These securities will no longer be listed
                  in the security master.</p>
                }
                @if (warningsData?.processArray?.length <= 1 ) {
                  <p>Note: This security will no longer be listed in
                  the security master.</p>
                }
                <p><strong>Move selections into: {{warningsData?.currentGroupSecurity?.securitySymbol}} </strong>
              </p>
            </div>
          }
        </div>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary grey">Cancel</button>
  <button class="btn-medium-primary" (click)="onContinue()"
  [disabled]="disbleContinue">{{getContinueButtonText()}}</button>
</mat-dialog-actions>
